import { Instagram, Linkedin } from "lucide-react";

// Canonical social handles for Manodayam.
// Kept in one place so we can update once and reflect everywhere.
export const SOCIAL_LINKS = [
  {
    key: "manodayam-instagram",
    label: "Manodayam on Instagram",
    handle: "@manodayam_com",
    href: "https://www.instagram.com/manodayam_com/",
    icon: Instagram,
    brand: "manodayam",
  },
  {
    key: "manodayam-linkedin",
    label: "Manodayam on LinkedIn",
    handle: "Manodayam",
    href: "https://in.linkedin.com/company/manodayam",
    icon: Linkedin,
    brand: "manodayam",
  },
];

/**
 * SocialLinks - reusable footer/sidebar/card social link row.
 * variant: "row" (compact icons, single row) | "grid" (label + handle cards)
 */
export default function SocialLinks({
  variant = "row",
  className = "",
  size = 18,
  testid = "social-links",
}) {
  if (variant === "grid") {
    return (
      <div
        data-testid={testid}
        className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${className}`}
      >
        {SOCIAL_LINKS.map(({ key, label, handle, href, icon: Icon, brand }) => (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-${key}`}
            aria-label={label}
            className="group flex items-center gap-3 px-4 py-3 rounded-2xl border border-[color:var(--mano-border)] bg-white hover:border-[color:var(--mano-primary)] hover:bg-[color:var(--mano-border)]/30 transition-colors"
          >
            <span
              className={`h-9 w-9 rounded-xl flex items-center justify-center ${
                brand === "manodayam"
                  ? "bg-[color:var(--mano-primary)]/10 text-[color:var(--mano-primary)]"
                  : "bg-[color:var(--mano-blue-brand,#1d4ed8)]/10 text-[color:var(--mano-blue-brand,#1d4ed8)]"
              }`}
            >
              <Icon size={size} />
            </span>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-[color:var(--mano-ink)] truncate">
                {label}
              </div>
              <div className="text-xs text-[color:var(--mano-ink-soft)] truncate">
                {handle}
              </div>
            </div>
          </a>
        ))}
      </div>
    );
  }

  // row variant - compact icon-only row
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-2 ${className}`}
    >
      {SOCIAL_LINKS.map(({ key, label, href, icon: Icon }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-${key}`}
          aria-label={label}
          title={label}
          className="h-9 w-9 rounded-full border border-[color:var(--mano-border)] text-[color:var(--mano-ink-soft)] hover:text-[color:var(--mano-primary)] hover:border-[color:var(--mano-primary)] hover:bg-[color:var(--mano-border)]/40 flex items-center justify-center transition-colors"
        >
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
